import { Injectable } from '@angular/core';
import { FlamingoHttpService } from '../../../@flamingo/service/flamingo-http.service';
import { Observable } from 'rxjs';
import { AccountUpdate } from '../model/account-update.model';
import { AccountView } from '../model/account-view.model';
import { API_ENDPOINTS } from '../constants/api.constants';

@Injectable({
    providedIn: 'root',
})
export class MainService {

    constructor(
        private _httpService: FlamingoHttpService
    ) {
    }

    private _user: AccountView | null = null;

    get user(): AccountView | null {
        return this._user;
    }

    set user(value: AccountView | null) {
        this._user = value;
    }

    public getAccount(): Observable<AccountView> {
        return this._httpService.get(API_ENDPOINTS.ACCOUNT.PROFILE);
    }

    public updateAccount(account: AccountUpdate): Observable<AccountView> {
        return this._httpService.put(API_ENDPOINTS.ACCOUNT.PROFILE, account);
    }
}
